import RawMaterials from "../../components/Materials/RawMaterials";
import styles from "./RowMaterialPage.module.css";

export default function RawMaterialsPage() {
  return (
    <div className={styles.page}>
      <RawMaterials />
    </div>
  );
}
